import React from "react";

const HeaderSection = () => {
  return (
    <div className="header_section">
      <a href="#stack">MY STACK</a>
      <a href="#EXPERIENCE">EXPERIENCE</a>
      <a href="#PROJECTS">PROJECTS</a>
      <a href="#contacts">CONTACTS</a>
    </div>
  );
};

export default HeaderSection;
